import { CEPaymentIntentAttributesBase } from './ce-payment-intent-attributes-base'


export class CEPaymentIntentAttributes extends CEPaymentIntentAttributesBase {

}